export default "__VITE_ASSET__0d73d833__"